module.exports = {
  dimensions: {
    width: 14,
    height: 39
  },
  content: {
    top: 0,
    left: 0,
    right: 1,
    bottom: 0
  },
  optical: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};